import { Injectable } from '@angular/core';
import { SupabaseCore } from './supabase.core';

@Injectable({
  providedIn: 'root',
})
export class SupabaseDatabase {
  constructor(private supabaseCore: SupabaseCore) {}

  from<T = any>(table: string) {
    return this.supabaseCore.client.from(table);
  }

  async rpc<T = any>(functionName: string, options: any): Promise<T> {
    const { data, error } = await this.supabaseCore.client.rpc(functionName, options);

    if (error) throw error;
    return data as T;
  }

  async select<T = any>(table: string, columns = '*'): Promise<T[]> {
    const { data, error } = await this.supabaseCore.client.from(table).select(columns);

    if (error) throw error;
    return data as T[];
  }

  async insert<T = any>(table: string, data: Partial<T>): Promise<T> {
    const { data: result, error } = await this.supabaseCore.client
      .from(table)
      .insert(data)
      .select()
      .single();

    if (error) throw error;
    return result as T;
  }

  async update<T = any>(table: string, data: Partial<T>, match: Record<string, any>): Promise<T> {
    const { data: result, error } = await this.supabaseCore.client
      .from(table)
      .update(data)
      .match(match)
      .select()
      .single();

    if (error) throw error;
    return result as T;
  }

  async delete<T = any>(table: string, match: Record<string, any>): Promise<void> {
    const { error } = await this.supabaseCore.client.from(table).delete().match(match);

    if (error) throw error;
  }

  async upsert<T = any>(table: string, data: Partial<T>): Promise<T> {
    const { data: result, error } = await this.supabaseCore.client
      .from(table)
      .upsert(data)
      .select()
      .single();

    if (error) throw error;
    return result as T;
  }
}
